// Customizable Area Start
import React, { Component } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Fade from "@mui/material/Fade";
import CustomInfoIcon from "./CustomInfoIcon.web";

const DEFAULT_MESSAGE = "Something went wrong!";

const CustomDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    backgroundColor: "#fff",
    padding: "50px 40px",
    position: "relative",
    maxWidth: "530px",
    width: "100%",
    minHeight: "340px",
    "@media (max-width: 768px)": {
      padding: "40px 30px"
    },
    "@media (max-width: 450px)": {
      padding: "40px 20px",
      height: "auto",
      minHeight: "auto",
    },
  },
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: "15px",
  right: "15px",
  padding: "3px",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.05)",
  },
  "& svg": {
    color: "#0F172A",
    fontSize: "23px",
  },
});

const MainWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flexGrow: 1,
});

const InfoMessage = styled(Typography)({
  fontWeight: 600,
  color: "#000000",
  fontSize: "clamp(1.3rem, 4.8vw, 1.75rem)",
  lineHeight: "clamp(28px, 4.5vw, 32px)",
  textAlign: "center",
  whiteSpace: "pre-line",
  marginTop: "30px",
  maxWidth: "90%",
  "@media (max-width: 768px)": {
    maxWidth: "95%"
  },
  "@media (max-width: 450px)": {
    maxWidth: "100%"
  },
});

const InfoDescription = styled(Typography)({
  fontWeight: 400,
  color: "#64748B",
  fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
  lineHeight: "clamp(20px, 3.5vw, 24px)", 
  textAlign: "center",
  whiteSpace: "pre-line",
  marginTop: "14px",
   maxWidth: "90%",
  "@media (max-width: 768px)": {
    maxWidth: "95%"
  },
  "@media (max-width: 450px)": {
    maxWidth: "100%"
  },
});

export type InfoType = "success" | "error";

interface Props {
  title: string;
  description?: string;
  isOpen: boolean;
  infoType: InfoType;
  handleClose: () => void;
}

class CustomInfoDialog extends Component<Props> {
  render() {
    const { isOpen, infoType, title, description, handleClose } = this.props;
    return (
      <CustomDialog
        data-test-id="custom-info-dialog"
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={Fade}
        transitionDuration={300}
      >
        <CloseButton data-test-id="info-dialog-close" onClick={handleClose}>
          <CloseRoundedIcon />
        </CloseButton>
        <DialogContent sx={{ display: "flex", padding: "0" }}>
          <MainWrapper>
            <CustomInfoIcon infoType={infoType} />
            <InfoMessage data-test-id="info-message">
              {title || DEFAULT_MESSAGE}
            </InfoMessage>
            <InfoDescription data-test-id="info-description">
              {description}
            </InfoDescription>
          </MainWrapper>
        </DialogContent>
      </CustomDialog>
    );
  }
}

export default CustomInfoDialog;
// Customizable Area End
